import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M14.25 14.75H3.75V4.25H9v-1.5H3.75c-.8325 0-1.5.675-1.5 1.5v10.5c0 .825.6675 1.5 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V9.5h-1.5zm-3.75-12v1.5h2.6925L5.82 11.6225 6.8775 12.68 14.25 5.3075V8h1.5V2.75z" /></g>,<defs key="1"></defs>,]
, 'ActionOpenLinkx');
